import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform, Events, ModalController, ToastController } from 'ionic-angular';
import { TransactionAlertProvider } from '../../providers/transaction-alert/transaction-alert';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { Camera,CameraOptions } from '@ionic-native/camera';
import {ProfileCropPage} from '../profile-crop/profile-crop';
import { File } from '@ionic-native/file';
import { CONFIG } from "../../config/config";
import { LoadingProvider } from '../../providers/loading/loading';
declare var cordova:any;

/**
 * Generated class for the ProfileNewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface BizImage {
  id: number,
  url: string,
}
@IonicPage()
@Component({
  selector: 'page-profile-new',
  templateUrl: 'profile-new.html',
})
export class ProfileNewPage {

  public deleteMode: boolean = false;
  public bizImages: BizImage[] = [];
  public addingImage: boolean = false;
  public bizImage:any ;
  public path: any;
  private agentCode : string = window.localStorage.getItem('agentCode'); 
// from old profile page.
  public profileImage;
  public croppedImage;
  public show = true;
  public profileInfo = JSON.parse(window.localStorage.getItem('agentObj'));
  public agentIncome = {};
 

  constructor(public navCtrl: NavController, private event: Events, public navParams: NavParams,private request: RequestServiceProvider,  private loading: LoadingProvider, private platform: Platform, private alert: TransactionAlertProvider,private camera: Camera,  private modal: ModalController, private toastCtrl: ToastController) {
  }

  array(length){
    return Array(length).fill(0);
  }

  removeImage(image){
    this.bizImages = this.bizImages.filter(i => i != image);
    const postData =  this.bizImages.map(img => img.url.slice(-15) )
    this.deleteImage(postData);
    this.deleteMode = !!this.bizImages.length
  }

  add(){
    this.bizImages.push({
      id: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),
      url: 'http://placehold.it/90x90'
    })
  }

  agentPhotoSelfie() {
    const options: CameraOptions = {
      quality: 30,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      cameraDirection: this.camera.Direction.FRONT,
      correctOrientation: true
    };
    this.camera.getPicture(options).then((imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):
      this.profileImage = 'data:image/jpeg;base64,' + imageData;
      this.openModal();
      // this.show = false;
    }, (err) => {
      // Handle error
    });
  }

  openModal() {
    const profileModal = this.modal.create(ProfileCropPage, {data: this.profileImage});
    profileModal.present();
    profileModal.onDidDismiss(data => {
      this.croppedImage = data;

      let profileData = {
        agentCode: window.localStorage.getItem('agentCode'),
        image: this.croppedImage
      };

      this.event.publish('uploaded-image', this.croppedImage);

      this.request.postAgentProfile(profileData).subscribe(
        data => {
          this.presentToast();
        }
      );

      this.show = false;
    })
  }

  addBizImage() {
    
    const options: CameraOptions = {
      quality: 30,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
     // cameraDirection: this.camera.Direction.FRONT,
     // correctOrientation: true
    };

    this.camera.getPicture(options).then((imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):

      const img = 'data:image/jpeg;base64,' + imageData;
     // this.loading.presentLoading('upload...')

      this.postBizImage({agentCode:this.agentCode, image:img})
     }, (err) => {
      // Handle error
     });
  
  }

  postBizImage(data) {
    this.loading.presentLoading('Uploading...')
    this.request.postAgentBusinessProfile(data)
                .subscribe(res => {
                  this.bizImages.length = 0 
                  res.json().forEach(item => {
                    this.bizImages.push({
                      id: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),
                      url: `${CONFIG.laravelUrl}/uploads/profiles/${item}`
                    })
                  })
                  this.loading.loader.dismiss().catch(()=>{});
                },error => {
                  this.loading.loader.dismiss().catch(()=>{});
                  this.alert.presentNormalAlert('Image upload failed.Try again')
                })
  }

  deleteImage(data) {
    this.loading.presentLoading('Deleting...')
    this.request.postDeleteAgentBusinessProfile({agentCode:this.agentCode, images:data})
                .subscribe(
                  res =>  {
                    this.loading.loader.dismiss().catch(()=>{});
                  },
                  error => {
                    this.loading.loader.dismiss().catch(()=>{});
                    this.alert.presentPendingAlert('Image delete failed.Try again')
                  }
                )
                
  }

  presentToast() {
    let toast = this.toastCtrl.create({
      message: 'Image Uploaded Sucessfully',
      duration: 3000,
      position: 'top'
    });

    toast.present();
  }

  ionViewWillLoad () {
    this.loading.presentLoading('loading...');
    this.request.getAgentProfileImg(window.localStorage.getItem('agentCode'))
      .subscribe(data => {
          this.loading.loader.dismiss().catch(() => {
          });
          if(data.business_images !== null){
            JSON.parse(data.business_images).forEach(item => {
              this.bizImages.push({
                id: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),
                url: `${CONFIG.laravelUrl}/uploads/profiles/${item}`
              })
            })
          }
          if (data.image_string == undefined) {
            this.show = true;
          } else {
            this.show = false;
            this.croppedImage = data.image_string;
          }
        },
        error => {
          this.loading.loader.dismiss().catch(() => {});
        }
      );

    this.request.getAgentProfileInfo()
      .subscribe(data => {
          this.agentIncome = data;
        },
        error => {
          if (error.code === 403) {
            this.request.logout();
          }
        }
      )
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/profile-new/profile-new.ts